import type { CapitalNeed } from '#/graphql/types';
import type { FormItem } from '#/common/components/Form';
import allFields from '../../utils/fields';
import { getHistorySection } from '#/common/utils/fields/historySection';

const mainSection: FormItem<CapitalNeed> = {
  cssClass: 'tmm-section',
  colCount: {
    xs: 1,
    sm: 1,
    md: 2,
    lg: 2,
  },
  items: [
    {
      colSpan: 2,
      colCount: 3,
      items: [
        allFields.title,
        allFields.displayNumber,
        {
          ...allFields.assetId,
          editorOptions: { ...allFields.assetId.editorOptions, readOnly: true },
        },
      ],
    },
    allFields.cost,
    allFields.plannedDate,
    allFields.type,
    allFields.status,
    { ...allFields.description, colSpan: 2 },
  ],
};

export const createFields: FormItem<CapitalNeed>[] = [mainSection];

export const updateFields: FormItem<CapitalNeed>[] = [mainSection, getHistorySection()];
